import { Injectable } from '@angular/core';
import { BaseApi } from '../../base-api.service'; 
import { map } from 'rxjs';

@Injectable()
export class ManageAdminsService {
  private baseUrl = '/users';
  constructor(
    private api: BaseApi,
   
  ) { }

  getAllAdmins(data) {
    return this.api.postData(`/v1/manageAdmins/adminsList`,data).pipe(map(res => {
      return res;
    }))
  }

  addAdmin(admin) {
    return this.api.getComplt(`/company/add`, admin).pipe(map(res => {
      return res;
    }))
  }

  enableDisable(payload) {
    return this.api.postData(`/v1/manageAdmins/toggleActivity`, payload).pipe(map(res => {
      return res;
    }))
  }

  generateLogReport(adminId) {
    // return this.api.newGet(`/pdf/getLogDataForAdmin/${adminId}`).map(report => {
    //   console.log(report);
    //   return report;
    // })
    return this.api.postData(`/v1/manageAdmins/adminLogs`, adminId).pipe(map(report => {
      console.log(report);
      return report;
    }))
  }

  generateLogReportSuperAdmin(adminId) {
    // return this.api.newGet(`/pdf/getLogDataForAdmin/${adminId}`).map(report => {
    //   console.log(report);
    //   return report;
    // })
    return this.api.postData(`/pdf/getExcelForSuperAdmin/`, adminId).pipe(map(report => {
      console.log(report);
      return report;
    }))
  }

  generateLogReportCanara(adminId) {
    return this.api.postData(`/pdf/getExcelForAdminCanara/`, adminId).pipe(map(report => {
      console.log(report);
      return report;
    }))
  }

  generateLogReportSuperAdminCanara(adminId) {
    return this.api.postData(`/pdf/getExcelForSuperAdminCanara/`, adminId).pipe(map(report => {
      console.log(report);
      return report;
    }))
  }

  getReportingManagers() {
    return this.api.getComplt(`${this.baseUrl}/getGroupSalesManagers`);
  }



    submitAddUser(data,stateIdentifier) {
      console.log("stateIdentifier",stateIdentifier,typeof(stateIdentifier))
      
    return this.api.postUser('/v1/dashboard/createUser', data,stateIdentifier).pipe(map(resp => {
      return resp;

    
    }))
  }

  
  fetchUsers(roleId) {
    return this.api.getComplt(`/v1/dashboard/fetchUsers?roleId=${roleId}`).pipe(map(resp => {
      return resp;
    }))
  }

  fetchLocations(adminId: string) {
    return this.api.getComplt(`/v1/dashboard/branches?adminId=${adminId}`).pipe(map(resp => {
      return resp;
    }))
  }

}
